"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseType = void 0;
var LicenseType;
(function (LicenseType) {
    LicenseType["ENTRY"] = "entry";
    LicenseType["STANDARD"] = "standard";
    LicenseType["ENTERPRISE"] = "enterprise";
})(LicenseType = exports.LicenseType || (exports.LicenseType = {}));
